export const truncateDecimal = (value, precision = 1) => {
  if (value == null || isNaN(value)) return value;

  const factor = Math.pow(10, precision);
  return Math.trunc(value * factor) / factor;
};
